import type { ActivityType } from '@repo/utils';

export const getCustomActivities = `
  query getCustomActivities {
    activities(activityType: custom) {
      id
      displayName
    }
  }
`;

export type CustomActivity = Pick<ActivityType, 'id' | 'displayName'>;

export interface GetCustomActivitiesType {
  activities: CustomActivity[];
}

export function transformCustomActivities(data?: GetCustomActivitiesType) {
  return data?.activities?.map((activity) => ({
    value: activity.id,
    label: activity.displayName,
  })) ?? [];
}
